import ApiLocal from './api/local';
import Util from './util';
import tippy from 'tippy.js';

let lang;

let code = navigator.language || navigator.userLanguage;
code = code.split('-')[0];

let promise = ApiLocal.query('lang.get', null, {lang: code}).then((data) => lang = Util.tryJsonParse(data));

function get(path) {
    if (!lang || !path) return '';

    // find nested object property by string (e.g. modal.deleteAll.cancel will return lang[modal][deleteAll][cancel]
    // does null checking and returns an empty string if any property is null
    return path.split('.').reduce((data, segment) => {
        if (!data) return '';
        let next = data[segment];
        if (Util.isNull(next)) return '';
        return next;
    }, lang);
}

function replace() {    
    $('[data-lang-id]').each((index, el) => {
        const $el = $(el);
        let id = $el.data('lang-id');
        let tooltip = $el.data('cw-tooltip');
        if (!id) return console.warn('no id', id);
        let text = get(id);
        if (!text) return console.warn('no text for id', id);
        if(!tooltip) {
        $el.text(text);
        } else {
            tippy($el[0], {
                content: text,
                placement: 'bottom',
            })
        }
    })
}

$(() => {
    promise.then(replace);
});

export default {
    get,
    replace,
    promise
}